<template>
  <div v-if="isForceLogin" class="progress">
    <div class='indeterminate'></div>
  </div>
  <div v-else class="container a3d splash">
    <div class="row">
      <div class="col s12 center">
        <img class="responsive-img center-align" src="/static/img/siemens_logo.png">
      </div>
    </div>
    <div class="row center">
      <div class="col s6 right-align">
        <a @click='auth.login(true)' class="btn a3d inv">Sign up</a>
      </div>
      <div class="col s6 left-align">
        <a @click='auth.login(false)' class="btn a3d">Log in</a>
      </div>
      <p class="col s12 align-center" v-if="$route.path == '/logout'">You have logged out successfully</p>
    </div>
    <div class="reset-password-message" v-if="!isPassWasChanged">
      As Siemens security has now been added to this software as a service,
      you must change your password before logging in if you have not changed your password since June 5, 2020.
      Please follow next steps:
      <ul>
        <li>Click "Log in".</li>
        <li>Into Siemens login page click "Don't remember your password?".</li>
        <li>Follow the link from your E-mail.</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Splash',
    data () {
      return {
        isForceLogin: location.search.includes('?login=true')
      }
    },
    computed: {
      ...mapState([
        'user',
        'auth'
      ]),
      isPassWasChanged () {
        return document.cookie.match(`(^|;)?${this.user.isPassWasChangedCookieName}=([^;]*)`)
      }
    },
    created () {
      if (this.isForceLogin) {
        this.auth.login(false)
      }
    }
  }
</script>

<style scoped>
  a {
    cursor: pointer;
  }

  .responsive-img {
    max-width: 400px;
    margin: 0 30px;
  }

  .reset-password-message {
    padding: 20px 20px 10px;
    background: rgb(255, 220, 220);
    border: 2px solid rgb(255, 100, 100);
    border-radius: 20px;
    font-weight: 600;
    max-width: 660px;
    margin: 50px auto 0;
    text-align: justify;
  }

  .reset-password-message > ul > li {
    list-style-type: disc;
    margin-left: 40px;
  }
</style>




// WEBPACK FOOTER //
// Splash.vue?15ece530